module.exports = __webpack_public_path__ + "img/img10.283e421a.png";